import { Button, Card, Empty, List, Skeleton, Typography } from 'antd';
import usePrayerRequests from '@aims/shared/prayer-requests/use-prayer-requests';
import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import settings from '../../settings';

const { Title, Paragraph } = Typography;

const RecentPrayerRequests = ({ filters, queryId }) => {
  const [numPrayerRequestsShown, setNumPrayerRequestsShown] = useState(
    settings.smallPage,
  );
  const { data: prayerRequests, loading } = usePrayerRequests(filters, queryId);

  const locale = useSelector((store) => store.locale, shallowEqual);

  return (
    <>
      <Title level={3} style={{ marginBottom: 16 }}>
        Recent Prayer Requests
      </Title>
      {loading && (
        <List
          itemLayout="vertical"
          grid={{ column: 1, sm: 1, lg: 1, gutter: 15 }}
          dataSource={[0, 0, 0, 0]}
          renderItem={(item) => (
            <List.Item>
              <Card bordered={false}>
                <Skeleton loading="true" avatar active />
              </Card>
            </List.Item>
          )}
        />
      )}
      {!loading && (
        <List
          dataSource={prayerRequests.slice(0, numPrayerRequestsShown)}
          grid={{ column: 1, sm: 1, lg: 1, gutter: 12 }}
          rowKey="label"
          renderItem={(item) => (
            <List.Item>
              <Card>
                <Paragraph
                  style={{ fontWeight: 'bold', color: settings.colors.primary }}
                >
                  {`Created ${new Intl.DateTimeFormat(locale, {
                    dateStyle: 'medium',
                  }).format(new Date(item.createdAt))}`}
                </Paragraph>
                <Paragraph>{item.desc}</Paragraph>
              </Card>
            </List.Item>
          )}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Recent Prayer Requests"
              />
            ),
          }}
          loadMore={
            prayerRequests.length > numPrayerRequestsShown && (
              <div className="load-more">
                <Button
                  onClick={() =>
                    setNumPrayerRequestsShown(
                      numPrayerRequestsShown + settings.smallPage,
                    )
                  }
                >
                  View More
                </Button>
              </div>
            )
          }
        />
      )}
      <div style={{ height: 32 }} />
      <style jsx>{``}</style>
    </>
  );
};

export default RecentPrayerRequests;
